/**
 * Back to Top button behavior.
 * Shows/hides a #back-to-top button based on scroll position,
 * scrolls to top on click, and moves focus to the skip-to-main link.
 */
import './back-to-top.scss';
function throttle(callback, delay = 1000) {
  let shouldWait = false;
  let waitingArgs;
  const timeoutFunc = () => {
    if (waitingArgs == null) {
      shouldWait = false;
    } else {
      callback(...waitingArgs);
      waitingArgs = null;
      setTimeout(timeoutFunc, delay);
    }
  };

  return (...args) => {
    if (shouldWait) {
      waitingArgs = args;
      return;
    }

    callback(...args);
    shouldWait = true;
    setTimeout(timeoutFunc, delay);
  };
}

window.addEventListener('DOMContentLoaded', () => {
  const backToTopBtn = document.querySelector('#back-to-top');

  const scrollHandler = () => {
    if (window.scrollY > window.innerHeight / 2) {
      backToTopBtn.classList.remove('d-none');
    } else {
      backToTopBtn.classList.add('d-none');
    }
  };

  const throttledScrollHandler = throttle(scrollHandler, 500);

  if (backToTopBtn) {
    backToTopBtn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      scrollHandler();

      const handleScrollEnd = () => {
        const skipToMainLink = document.querySelector('.skip-to-main a');
        if (skipToMainLink) {
          skipToMainLink.focus();
        }
        document.removeEventListener('scrollend', handleScrollEnd);
      };
      document.addEventListener('scrollend', handleScrollEnd, { once: true });
    });

    document.addEventListener('scroll', () => {
      throttledScrollHandler();
    });
  }
});
